import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export function convertTimeToDayjs(time: string) {
  return dayjs(time, 'HH:mm');
}
